import React from 'react';

export function LoadMoreBar({ hasMore, loadingMore, onLoadMore, count }) {
  if (!hasMore) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '14px 0 4px' }}>
      <button type="button" className="btn btn-sm" disabled={loadingMore} onClick={onLoadMore}>
        {loadingMore ? 'Loading…' : count != null ? `Load more (${count} shown)` : 'Load more'}
      </button>
    </div>
  );
}

export default LoadMoreBar;
